// extracted by mini-css-extract-plugin
module.exports = {"Content":"Contents_Content__2yJNK","Expanded":"Contents_Expanded__2l_Yi"};